export { ModalHeading } from './ModalHeading';
export * from './ModalHeading.types';
